import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { fromJS } from 'immutable'
import Link from 'react-router/lib/Link'
import { Form, actions } from 'react-redux-form/immutable'

import { required, intRequired } from 'utils/validators'

import FormAdvising from './form-advising'
import { saveAdvising } from './actions'

const validators = {
  student_id: { intRequired },
  level: { required },
  semcamp_course_id: { intRequired },
  curriculum_id: { intRequired },
  payment_scheme_id: { intRequired },
}

class FormContainer extends Component {

  _onSubmit = (payload) => {
    const { dispatch } = this.props
    dispatch(saveAdvising(payload))
      .then((res) => {
        if (!res.error) {
          dispatch(actions.change('advisingState', fromJS(res.payload || {})))
          this.context.router.push(`/advising/${res.payload.student_id}`)
        }
      })
  }

  _renderButtons() {
    const { __pending, isShow, data, studentID } = this.props
    if (isShow) {
      return <Link to={`/advising/${studentID}/edit`} className="btn btn-default">Edit Advising</Link>
    } else {
      if (data) {
        return <button disabled={__pending} type="submit" className="btn btn-success">Update Advising</button>
      } else {
        return <button disabled={__pending} type="submit" className="btn btn-success">Save Advising</button>
      }
    }
  }

  render() {
    const { isShow, isNew } = this.props

    return (
      <Form
        model="advisingState"
        className="grid-form"
        onSubmit={this._onSubmit}
        validators={validators}
      >
        <div className="m-b-20 text-right">
          {this._renderButtons()}
        </div>
        <FormAdvising isShow={isShow} isNew={isNew} />
      </Form>
    )
  }
}

FormContainer.contextTypes = {
  router: PropTypes.object,
}

function mapStateToProps(state) {
  return {
    __pending: state.advising.get('pending'),
  }
}

export default connect(mapStateToProps)(FormContainer)



// WEBPACK FOOTER //
// ./src/containers/Advising/form-container.js